import { useQuery } from "@tanstack/react-query";
import api from "../lib/apiClient";

export const useSeo = (path) => {
    return useQuery({
        queryKey: ["seo", path],
        queryFn: async () => {
            const { data } = await api.get("/seo", {
                params: { path },
            });
            return data;
        },
    });
};